import React from "react";
import PropTypes from "prop-types";
import { Dispatcher, NavigatorAction } from "../../../flux";
import { Spinner } from "../../../components";
import Done from "./reading-complete/done";
import Next from "./reading-complete/next";

import ReadingProgress from "./reading-progress";

export default class ReadingComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      readings: [],
      loading: true
    };

    this._nextReading = this._nextReading.bind(this);
  }

  componentDidMount() {
    Dispatcher.emit(Dispatcher.MODAL_OPEN);
    const readings = this.props.readings.reduce((result, reading, index) => {
      result[reading.uuid] = index;
      return result;
    }, {});
    this.setState({ readings, loading: false }, () => {
      this.focusMount.focus();
    });
  }

  componentWillUnmount() {
    Dispatcher.emit(Dispatcher.MODAL_CLOSE);
  }

  _totalCompleted() {
    return this.props.readings.filter(r => r.completed_at).length;
  }

  _totalRemaining() {
    return this.props.readings.filter(reading => !reading.completed_at).length;
  }

  _isAssignmentDone() {
    return this.props.readings.every(reading => reading.completed_at);
  }

  _isLastAssignment() {
    return (
      this.state.readings[this.props.reading.uuid] ===
      this.props.readings.length - 1
    );
  }

  _nextReading() {
    if (this._isAssignmentDone()) {
      const currentIndex = this.state.readings[this.props.reading.uuid];
      if (currentIndex < this.props.readings.length - 1) {
        NavigatorAction.replace("assignment-reading", {
          reading: this.props.readings[currentIndex + 1]
        });
      } else {
        NavigatorAction.replace("reading-complete", {
          reading: this.props.reading
        });
      }
    } else {
      const reading = this.props.readings
        .filter(reading => !reading.completed_at)
        .shift();
      NavigatorAction.replace("assignment-reading", { reading });
    }
  }

  _minimize() {
    this.props.minimize({
      route: "reading-complete",
      currentReading: this.props.reading
    });
  }

  render() {
    if (!this.state.loading) {
      const completed = this._totalCompleted();
      const total = this.props.readings.length;
      return (
        <div id="reading-complete">
          <h1
            ref={header => {
              this.focusMount = header;
            }}
            tabIndex={-1}
            className="offScreen"
          >
            {i18n.t("assignments.progress", {
              completed: completed,
              total: total
            })}
          </h1>
          <ReadingProgress total={total} completed={this._totalCompleted()} />
          {this._isAssignmentDone() && this._isLastAssignment() ? (
            <Done
              firstReading={this.props.readings[0]}
              isbn={this.props.isbn}
              close={this.props.close}
            />
          ) : (
            <Next
              nextReading={this._nextReading}
              remaining={this._totalRemaining()}
              close={this.props.close}
            />
          )}
        </div>
      );
    }
    return (
      <div id="reading-complete">
        <Spinner />
      </div>
    );
  }
}

ReadingComplete.propTypes = {
  isbn: PropTypes.string.isRequired,
  book: PropTypes.object.isRequired,
  assignmentId: PropTypes.string,
  readings: PropTypes.array,
  assignment: PropTypes.object,
  reading: PropTypes.object
};
